<template>
  <div style="min-height: 92vh" class="pa-4">
    <div class="d-flex align-center mb-4">
      <h3 class="text-h5 font-weight-bold">Gestión de Menús Comandero</h3>
      <v-spacer></v-spacer>
    </div>

    <uv-data-table :config="config" :data="menusComandero" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>

    <modal v-model="showModal" :showFooter="false" :title="editMode ? 'Editar Menú Comandero' : 'Nuevo Menú Comandero'">
      <MenusComanderoForm :edit="editMode" :key="formKey" :dataEdit="editData" @toggle="showModal = false"
        @successData="successData" />
    </modal>
  </div>
</template>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import MenusComanderoForm from "./MenusComanderoForm.vue";

export default {
  name: "MenusComandero",
  components: {
    modal,
    uvDataTable,
    MenusComanderoForm,
  },
  data() {
    return {
      showModal: false,
      editMode: false,
      editData: {},
      formKey: 0,
      menusComandero: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "nm", Type: "Asc" },
        allowExport: true,
        rawText: "Menús Comandero",
        selectConfig: {
          idRowData: "Id",
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMenuComandero",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editMenuComandero",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteMenuComandero",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre de Menú",
            value: "nm",
            format: (row) => row.nm || row.Nombre || "",
          },
        ],
      },
    };
  },
  methods: {
    async getMenusComandero() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("AYB_MenuComanderos", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where(
          "Dlat",
          "==",
          null
        ),
      ]);
      if (data.empty) {
        this.menusComandero = [];
      } else {
        let doc = data.docs.map((doc) => {
          return { Id: doc.ref.id, ...doc.data() };
        });
        this.menusComandero = doc;
      }
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId === "addMenuComandero") {
        this.editMode = false;
        this.editData = {};
        this.formKey++;
        this.showModal = true;
      } else if (buttonId === "editMenuComandero") {
        this.editMode = true;
        this.editData = this.menusComandero.find((e) => e.Id === idSelected[0]);
        this.formKey++;
        this.showModal = true;
      } else if (buttonId === "deleteMenuComandero") {
        this.deleteMenuComandero(idSelected[0]);
      }
    },
    successData(data, mode) {

      if (mode === "CREATE") {
        this.$alert.alertConfirm({
          action: "crear",
          obj: "el menú comandero",
          route: "AYB-Comanderos-createMenuComandero",
          data: data,
          onSuccess: () => {
            this.getMenusComandero();
            this.showModal = false;
          },
        });
      } else {
        this.$alert.alertConfirm({
          action: "actualizar",
          obj: "el menú comandero",
          route: "AYB-Comanderos-updateMenuComandero",
          data: data,
          onSuccess: () => {
            this.getMenusComandero();
            this.showModal = false;
          },
        });
      }
    },
    deleteMenuComandero(id) {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("Id", id);
      formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
      this.$alert.alertConfirmFormData({
        action: "eliminar",
        route: "AYB-MenuComanderos-eliminarMenuComandero",
        data: formData,
        obj: "el menú comandero",
        onSuccess: () => {
          this.getMenusComandero();
        },
      });
    },
  },
  mounted() {
    this.getMenusComandero();
  },
};
</script>

<style scoped>
.text-h5 {
  color: #333;
}
</style>
